import * as api from "../../api/apiConnector.js";
import React, { useState, useEffect, useContext, useRef, useLayoutEffect } from "react";
import ReactDOM from "react-dom";
import { useParams } from "react-router-dom";
import DataTable from "datatables.net-dt";
// import 'datatables.net-dt/css/jquery.dataTables.css';

import * as breadcrumb from "../../components/ui/breadcrumb.js";
import * as uploadManager from "../../components/ui/fileupload.js";
import * as labels from "../../components/localized/labels.js";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import UserContext from "../../components/User_Context.js";
import IconSelector from "../../components/Icon_Selector.js";
import IconFolder from "../../assets/icon/mimetype/icons8-folder.svg";
import { Menu, Item, Separator, useContextMenu } from "react-contexify";
import "react-contexify/ReactContexify.css";
import * as menu from "../../assets/menus/menu.js";
import waiting from "../../assets/images/waiting.svg";
import { folder_selector_widget } from "./folder_selector_widget.js";
import * as utils from "../../components/utils.js";
import * as icons from "../../components/fileTypesIcons.js";
import cloud_icon from "../../assets/images/cloud.svg";
import { useTranslation } from "react-i18next";
import Choices from "../../components/Choices.js";
import {
  hasApprovalRights,
  hasValidatorRights,
  hasEditorRights,
  hasAdministrationRights,
} from "../../assets/menus/menu_helper.js";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import EditPanel from "./components/edit_panel.js";
import { EditPanelProvider } from "./components/edit_panel_context.js";

function DMS_Screen(params) {
  const [content, setContent] = useState(null);
  const [originalContent, setOriginalContent] = useState(null);
  const [refresh, setRefresh] = useState(null);
  const { id = null } = useParams();
  const { currentUser } = useContext(UserContext);
  const { mode = "default" } = params;
  const [selected, setSelected] = useState([]);
  const [showEdit, setShowEdit] = useState(true);
  const [semanticSearch, setSemanticSearch] = useState(false);
  const { t } = useTranslation("labels");
  const [highlightedRowId, setHighlightedRowId] = useState(null);
  const permissionsTableRef = useRef(null);
  const permissionsDataTableRef = useRef(null);
  const mainDataTableRef = useRef(null);
  const uploadFileInputRef = useRef(null);
  const [permissionsToUse, setPermissionToUse] = useState(null);
  const searchChangeTimerRef = useRef(null);

  // Vocabulary states for dropdowns
  const [item, setItem] = useState(null);
  const [metaData, setMetadata] = useState(null);
  const [dmsClassificationVoc, setDmsClassificationVoc] = useState([]); // Classification vocabulary

  const [selectedStatusForSearch, setSelectedStatusForSearch] = useState([]); // Validation flow for search
  const [selectedClassificationForSearch, setSelectedClassificationForSearch] =
    useState([]); // Classification for search
  const [selectedKeywordsForSearch, setSelectedKeywordsForSearch] = useState(
    []
  ); // Keywords for search
  const [selectedCategoriesForSearch, setSelectedCategoriesForSearch] =
    useState([]); // Categories for search
  const [selectedOrganizationsForSearch, setSelectedOrganizationsForSearch] =
    useState([]); // Organizations for search
  const [searchText, setSearchText] = useState(""); // Current search text
  const [isAdvancedSearchLoading, setIsAdvancedSearchLoading] = useState(false);

  const [dmsCategoriesVoc, setDmsCategoriesVoc] = useState([]); // Categories vocabulary (DARM only)
  const [dmsFileKeywords, setDmsFileKeywords] = useState([]); // File Keywords
  const [dmsValidationFlowVoc, setDmsValidationFlowVoc] = useState([]);
  // Form state management
  const [toSave, setToSave] = useState(false); // Flag to enable/disable save button
  const [isSavingRightEditModal, setIsSavingRightEditModal] = useState(false);
  const [selectedClassifications, setSelectedClassifications] = useState([]); // Selected classifications
  const [selectedValidation, setSelectedValidation] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]); // Selected categories
  const [selectedFileKeywords, setSelectedFileKeywords] = useState([]); // Selected file keywords
  const [selectedOrganizationUnitIds, setSelectedOrganizationUnitIds] = useState([]); // Selected organization
  const [allKeywords, setAllKeywords] = useState([]); // All keywords
  const [forceRender, setForceRender] = useState(0); // Counter to force form re-render
  const [userRights, setUserRights] = useState(""); // 'editor' | 'validator' | 'approval' | null
  const [CanIEditLinkedFile, setCanIEditLinkedFile] = useState(false);

  const [downloadHistory, setDownloadHistory] = useState([]);
  const [statusHistory, setStatusHistory] = useState([]);
  const [linkedFiles, setLinkedFiles] = useState({
    filesLinkedToThis: [],
    filesLinkedFromThis: [],
  });

  const appProfile = process.env.REACT_APP_PROFILE;
  let itemIdForContextMenu;
  const { show } = useContextMenu({
    id: "contextMenu",
  });

  useEffect(() => {
    const user = currentUser();
    if (user) {
      if (hasAdministrationRights(user) || hasApprovalRights(user)) {
        setUserRights("approval");
      } else if (hasValidatorRights(user)) {
        setUserRights("validator");
      } else if (hasEditorRights(user)) {
        setUserRights("editor");
      }
    }
  }, [currentUser]);

  const searchOrganizationUnits = async (inputValue) => {
    const query = String(inputValue ?? "").trim();
    if (query.length === 0) return [];

    try {
      const result = await api.sendMessage(
        "admin/system/organization/searchSmallBusinessUnit",
        {
          user: currentUser(),
          body: {
            text: query,
          },
        }
      );
      if (result.success) {
        const units = Array.isArray(result?.units) ? result.units : [];
        return units.map((o) => ({
          label: o?.name ?? o?.Name ?? "",
          value: o?.id ?? o?.Id ?? "",
        }));
      }
    } catch (error) {
      console.error("Error searching organization units:", error);
      return [];
    }
  };

  const loadDownloadHistory = async (id) => {
    try {
      const result = await api.sendMessage("dms/retrieveDownload", {
        user: currentUser(),
        body: {
          id: id,
        },
      });
      if (result?.success) {
        setDownloadHistory(result.downloads || []);
      }
    } catch (error) {
      console.error("Error loading download history:", error);
    }
  };

  const loadStatusHistory = async (id) => {
    try {
      const result = await api.sendMessage("dms/retrieveStatusChanges", {
        user: currentUser(),
        body: { id: id },
      });
      if (result?.success) {
        setStatusHistory(result.status_changes || []);
      }
    } catch (error) {
      console.error("Error loading status history:", error);
    }
  };

  const loadLinkedFiles = async (id) => {
    try {
      const result = await api.sendMessage("dms/retrieveLinkedFiles", {
        user: currentUser(),
        body: { id: id },
      });
      if (result?.success) {
        setLinkedFiles({
          filesLinkedToThis: result.filesLinkedToThis || [],
          filesLinkedFromThis: result.filesLinkedFromThis || [],
        });
      }
    } catch (error) {
      console.error("Error loading linked files:", error);
    }
  };

  const loadVocabularies = async () => {
    try {
      // Load classification vocabulary (available for all profiles)
      const classificationResult = await api.sendMessage("admin/vocs/get", {
        user: currentUser(),
        body: { voc_id: "dms_classification_types" },
      });
      if (classificationResult.success) {
        setDmsClassificationVoc(classificationResult.items || []);
      }

      const validationResult = await api.sendMessage("admin/vocs/get", {
        user: currentUser(),
        body: { voc_id: "dms_files_validation_flow" },
      });
      if (validationResult.success) {
        setDmsValidationFlowVoc(validationResult.items || []);
      }

      // Load categories vocabulary
      const categoriesResult = await api.sendMessage("admin/vocs/get", {
        user: currentUser(),
        body: { voc_id: "dms_category_types" },
      });
      if (categoriesResult.success) {
        setDmsCategoriesVoc(categoriesResult.items || []);
      }
    } catch (error) {
      console.error("Error loading vocabularies:", error);
    }

    const getKeywords = await api.sendMessage("dms/allKeywords", {
      user: currentUser(),
    });
    if (getKeywords.success) {
      setAllKeywords(getKeywords.keywords || []);
    }
  };

  const getMetadata = async (item) => {
    try {
      var getMeta = await api.sendMessage("dms/getMeta", {
        user: currentUser(),
        body: {
          id: item?.LastVersion,
          fileId: item?.Id,
        },
      });
      if (getMeta.success) {
        setMetadata(getMeta || null);
        setCanIEditLinkedFile(getMeta.canIDoIt || false);
      }
    } catch (error) {
      console.error("Error getting metadata:", error);
    }
  };

  const populateClassifications = async () => {
    if (
      metaData &&
      metaData.classifications &&
      Array.isArray(metaData.classifications)
    ) {
      // Wait for classification vocabulary to be loaded
      while (dmsClassificationVoc.length === 0) {
        await new Promise((resolve) => setTimeout(resolve, 100));
      }

      // Map classification codes to full vocabulary objects
      const initialClassifications = metaData.classifications
        .map((classificationObj) =>
          dmsClassificationVoc.find(
            (voc) => voc.Code === classificationObj.ClassificationCode
          )
        )
        .filter(Boolean); // Remove undefined values

      setSelectedClassifications(initialClassifications);
      setForceRender((prev) => prev + 1); // Force form re-render
    } else {
      setSelectedClassifications([]);
    }
  };

  const fetchOrganizationUnitOptionById = async (businessUnitId) => {
    if (!businessUnitId) return null;
    try {
      // First try to resolve via full list to match exact id
      const unitsRes = await api.sendMessage(
        "admin/system/organization/get_business_units",
        { user: currentUser() }
      );
      if (unitsRes?.success && Array.isArray(unitsRes?.units)) {
        const match = unitsRes.units.find(
          (u) =>
            String(u?.id ?? u?.Id ?? "") === String(businessUnitId) ||
            String(u?.BusinessUnitId ?? "") === String(businessUnitId)
        );
        if (match) {
          const id = match?.id ?? match?.Id ?? businessUnitId;
          const name = match?.name ?? match?.Name ?? id;
          return { label: String(name), value: String(id) };
        }
      }

      // Fallback to search by text if list does not include it
      const searchRes = await api.sendMessage(
        "admin/system/organization/searchSmallBusinessUnit",
        { user: currentUser(), body: { text: String(businessUnitId) } }
      );
      if (searchRes?.success && Array.isArray(searchRes?.units)) {
        const normalized = searchRes.units.map((o) => ({
          id: o?.id ?? o?.Id ?? "",
          name: o?.name ?? o?.Name ?? "",
        }));
        const match = normalized.find(
          (u) => String(u.id) === String(businessUnitId)
        );
        if (match && match.id) {
          return { label: match.name || String(match.id), value: String(match.id) };
        }
      }
    } catch (err) {
      // noop, fallback below
    }
    return { label: String(businessUnitId), value: String(businessUnitId) };
  };

  const populateOrganizationUnitIds = async () => {
    const businessUnits = metaData && metaData.businessUnit;
    if (Array.isArray(businessUnits) && businessUnits.length > 0) {
      const first = businessUnits[0] || {};
      const id =
        first?.BusinessUnitId ?? first?.Id ?? first?.businessUnitId ?? null;
      let name = first?.BusinessUnitName ?? first?.Name ?? "";

      if (id) {
        if (!name || String(name) === String(id)) {
          const option = await fetchOrganizationUnitOptionById(id);
          setSelectedOrganizationUnitIds(option);
        } else {
          setSelectedOrganizationUnitIds({
            label: String(name),
            value: String(id),
          });
        }
        setForceRender((prev) => prev + 1); // Force form re-render
        return;
      }
    }

    setSelectedOrganizationUnitIds(null);
  };

  const populateValidationFlow = async () => {
    if (metaData && metaData.FileStatus) {
      // Wait for categories vocabulary to be loaded
      while (dmsValidationFlowVoc.length === 0) {
        await new Promise((resolve) => setTimeout(resolve, 100));
      }

      // Map category codes to full vocabulary objects
      const initialValidation = dmsValidationFlowVoc.find(
        (voc) => voc.Code === metaData.FileStatus
      ); // Remove undefined values
      setSelectedValidation([initialValidation]);
      setForceRender((prev) => prev + 1); // Force form re-render
    } else {
      setSelectedValidation([]);
    }
  };

  const populateCategories = async () => {
    if (metaData && metaData.categories && Array.isArray(metaData.categories)) {
      // Wait for categories vocabulary to be loaded
      while (dmsCategoriesVoc.length === 0) {
        await new Promise((resolve) => setTimeout(resolve, 100));
      }

      // Map category codes to full vocabulary objects
      const initialCategories = metaData.categories
        .map((categoryObj) =>
          dmsCategoriesVoc.find((voc) => voc.Code === categoryObj.CategoryCode)
        )
        .filter(Boolean); // Remove undefined values

      setSelectedCategories(initialCategories);
      setForceRender((prev) => prev + 1); // Force form re-render
    } else {
      setSelectedCategories([]);
    }
  };

  const populateFileKeywords = async () => {
    if (metaData && metaData.keywords && Array.isArray(metaData.keywords)) {
      // De-duplicate while preserving order and shape { Keyword: string }
      const uniqueKeywordsMap = new Map();
      for (const kw of metaData.keywords) {
        const raw = kw?.Keyword;
        if (raw === undefined || raw === null) continue;
        const key = String(raw).trim();
        if (!key) continue;
        if (!uniqueKeywordsMap.has(key)) {
          uniqueKeywordsMap.set(key, { Keyword: key });
        }
      }

      const initialKeywords = Array.from(uniqueKeywordsMap.values());
      setSelectedFileKeywords(initialKeywords);

      setDmsFileKeywords(initialKeywords);
      setForceRender((prev) => prev + 1); // Force form re-render
    } else {
      setSelectedFileKeywords([]);
      setDmsFileKeywords([]);
    }
  };

  // Method to create permissions table with DataTables.js
  const createPermissionsTable = (container, item) => {
    // Build table HTML structure
    const tableHtml = `
        <div class="d-flex justify-content-end align-items-center mb-3">
          <button type="button" class="btn btn-success btn-sm" id="addToPermission">
            <i class="fa fa-plus me-1"></i>
            ${t("addToPermission", { ns: "labels" })}
          </button>
        </div>
      <div class="table-responsive">
        <table id="permissionsTable" class="table table-striped">
          <thead>
            <tr>
              <th>${t("userGroup", { ns: "labels" })}</th>
              <th class="text-center">Read</th>
              <th class="text-center">Write</th>
              <th class="text-center">List</th>
              <th class="text-center">Delete</th>
              <th class="text-center">Execute</th>
            </tr>
          </thead>
          <tbody>
            ${buildTableRows()}
          </tbody>
        </table>
      </div>
      <div class="mt-3 text-end">
        <button type="button" class="btn btn-secondary me-2" data-bs-dismiss="modal">
          ${t("close", { ns: "labels" })}
        </button>
        <button type="button" class="btn btn-primary" id="savePermissionsBtn">
          ${t("save", { ns: "labels" })}
        </button>
      </div>
    `;

    // Build table rows for users and groups using permissionsToUse state
    function buildTableRows() {
      let rows = "";

      if (!permissionsToUse) return rows;

      // Add users
      if (permissionsToUse.users && permissionsToUse.users.length > 0) {
        permissionsToUse.users.forEach((userPerm) => {
          const userId = userPerm.Id;
          const user = userPerm.User;
          const displayName = `${user.Name} ${user.LastName} (${user.EMail})`;

          rows += `
            <tr data-id="${userId}" data-type="user">
              <td class="align-middle">
                <i class="fa fa-user me-2"></i>
                <strong>${displayName}</strong>
              </td>
              <td class="text-center">
                <input type="checkbox" class="form-check-input permission-checkbox" 
                       data-permission="Can_Read" ${
                         userPerm.Can_Read ? "checked" : ""
                       }>
              </td>
              <td class="text-center">
                <input type="checkbox" class="form-check-input permission-checkbox" 
                       data-permission="Can_Write" ${
                         userPerm.Can_Write ? "checked" : ""
                       }>
              </td>
              <td class="text-center">
                <input type="checkbox" class="form-check-input permission-checkbox" 
                       data-permission="Can_List" ${
                         userPerm.Can_List ? "checked" : ""
                       }>
              </td>
              <td class="text-center">
                <input type="checkbox" class="form-check-input permission-checkbox" 
                       data-permission="Can_Delete" ${
                         userPerm.Can_Delete ? "checked" : ""
                       }>
              </td>
              <td class="text-center">
                <input type="checkbox" class="form-check-input permission-checkbox" 
                       data-permission="Can_Execute" ${
                         userPerm.Can_Execute ? "checked" : ""
                       }>
              </td>
            </tr>
          `;
        });
      }

      // Add groups
      if (permissionsToUse.groups && permissionsToUse.groups.length > 0) {
        permissionsToUse.groups.forEach((groupPerm) => {
          const groupId = groupPerm.Id;
          const group = groupPerm.Group;
          const displayName = group.Name;

          rows += `
            <tr data-id="${groupId}" data-type="group">
              <td class="align-middle">
                <i class="fa fa-users me-2"></i>
                <strong>${displayName}</strong>
              </td>
              <td class="text-center">
                <input type="checkbox" class="form-check-input permission-checkbox" 
                       data-permission="Can_Read" ${
                         groupPerm.Can_Read ? "checked" : ""
                       }>
              </td>
              <td class="text-center">
                <input type="checkbox" class="form-check-input permission-checkbox" 
                       data-permission="Can_Write" ${
                         groupPerm.Can_Write ? "checked" : ""
                       }>
              </td>
              <td class="text-center">
                <input type="checkbox" class="form-check-input permission-checkbox" 
                       data-permission="Can_List" ${
                         groupPerm.Can_List ? "checked" : ""
                       }>
              </td>
              <td class="text-center">
                <input type="checkbox" class="form-check-input permission-checkbox" 
                       data-permission="Can_Delete" ${
                         groupPerm.Can_Delete ? "checked" : ""
                       }>
              </td>
              <td class="text-center">
                <input type="checkbox" class="form-check-input permission-checkbox" 
                       data-permission="Can_Execute" ${
                         groupPerm.Can_Execute ? "checked" : ""
                       }>
              </td>
            </tr>
          `;
        });
      }

      return rows;
    }

    // Clear container and add table
    container.html(tableHtml);

    // Get table reference after HTML is inserted
    const tableElement = document.getElementById("permissionsTable");

    // Destroy existing DataTable if it exists
    if (permissionsDataTableRef.current) {
      permissionsDataTableRef.current.destroy();
      permissionsDataTableRef.current = null;
    }

    // Initialize new DataTable using the same pattern as queue_manager
    if (tableElement) {
      permissionsDataTableRef.current = new DataTable(tableElement, {
        searching: false,
        paging: false,
        ordering: false,
        info: false,
        autoWidth: false,
        lengthChange: false,
        columnDefs: [{ targets: [1, 2, 3, 4, 5], className: "text-center" }],
      });
    }

    // Handle add user/group button click
    window
      .$("#addToPermission")
      .off("click")
      .on("click", function () {
        // Don't hide the permission modal, just open the add user modal on top
        openAddUserGroupModal(item);
      });

    // Handle checkbox changes
    window
      .$(document)
      .off("change", ".permission-checkbox")
      .on("change", ".permission-checkbox", function () {
        const checkbox = window.$(this);
        const row = checkbox.closest("tr");
        const entityId = row.data("id");
        const entityType = row.data("type");
        const permission = checkbox.data("permission");
        const isChecked = checkbox.is(":checked");

        // Update permissionsToUse state
        setPermissionToUse((prevPermissions) => {
          const newPermissions = utils.clone(prevPermissions);

          if (entityType === "user" && newPermissions.users) {
            const userIndex = newPermissions.users.findIndex(
              (u) => u.Id == entityId
            );
            if (userIndex !== -1) {
              newPermissions.users[userIndex][permission] = isChecked;
            }
          } else if (entityType === "group" && newPermissions.groups) {
            const groupIndex = newPermissions.groups.findIndex(
              (g) => g.Id == entityId
            );
            if (groupIndex !== -1) {
              newPermissions.groups[groupIndex][permission] = isChecked;
            }
          }

          return newPermissions;
        });
      });

    // Handle save button click
    window
      .$("#savePermissionsBtn")
      .off("click")
      .on("click", async function () {
        const saveBtn = window.$(this);
        const originalText = saveBtn.text();

        try {
          saveBtn
            .prop("disabled", true)
            .html('<i class="fa fa-spinner fa-spin me-1"></i> Saving...');

          // Collect all permission changes from permissionsToUse
          const permissionUpdates = [];

          // Add users permissions
          if (permissionsToUse?.users) {
            permissionsToUse.users.forEach((userPerm) => {
              permissionUpdates.push({
                type: "user",
                permissions: {
                  Id: userPerm.Id,
                  Can_Read: userPerm.Can_Read,
                  Can_Write: userPerm.Can_Write,
                  Can_List: userPerm.Can_List,
                  Can_Delete: userPerm.Can_Delete,
                  Can_Execute: userPerm.Can_Execute,
                  BackEnd_User_Id: userPerm.BackEnd_User_Id,
                  File_Id: userPerm.File_Id,
                  Folder_Id: userPerm.Folder_Id,
                },
              });
            });
          }

          // Add groups permissions
          if (permissionsToUse?.groups) {
            permissionsToUse.groups.forEach((groupPerm) => {
              permissionUpdates.push({
                type: "group",
                permissions: {
                  Id: groupPerm.Id,
                  Can_Read: groupPerm.Can_Read,
                  Can_Write: groupPerm.Can_Write,
                  Can_List: groupPerm.Can_List,
                  Can_Delete: groupPerm.Can_Delete,
                  Can_Execute: groupPerm.Can_Execute,
                  BackEnd_Group_Id: groupPerm.BackEnd_Group_Id,
                  File_Id: groupPerm.File_Id,
                  Folder_Id: groupPerm.Folder_Id,
                },
              });
            });
          }

          // Send update request to server
          const result = await api.sendMessage("dms/updateItemPermissions", {
            user: currentUser(),
            body: {
              itemType: item.type,
              itemId: item.item.Id,
              permissionUpdates: permissionUpdates,
            },
          });

          if (result.success) {
            withReactContent(Swal).fire({
              title: t("success", { ns: "labels" }),
              icon: "success",
              text: t("permissionsSaved", { ns: "labels" }),
              showConfirmButton: true,
              timer: 3000,
            });

            // Close modal after successful save
            setTimeout(() => {
              window.$("#permission-modal").modal("hide");
            }, 1500);
          } else {
            throw new Error(result.message || "Failed to save permissions");
          }
        } catch (error) {
          console.error("Error saving permissions:", error);
          withReactContent(Swal).fire({
            title: t("error", { ns: "labels" }),
            icon: "error",
            text: error.message || t("permissionsSaveError", { ns: "labels" }),
            showConfirmButton: true,
          });
        } finally {
          saveBtn.prop("disabled", false).text(originalText);
        }
      });
  };

  const createUserGroupsFinderForPermission = () => {
    const _selected = [];

    return (
      <div>
        {t("permissionParagraph", { ns: "labels" })}
        {
          <Choices
            voc={_selected}
            multiple={true}
            dropDownParent={"add-user-group-modal"}
            value={"Id"}
            text={"Name"}
            selected={_selected}
            minText={1}
            textDelegate={(item) => {
              const icon = item.type === "user" ? "👤" : "👥";
              //crea la const name che deve essere item.name e se esiste item.lastname deve includere anche quello
              const name =
                item.Name + (item.LastName ? ` ${item.LastName}` : "");
              const email = item.EMail ? ` (${item.EMail})` : "";
              return `${icon} ${name}${email}`;
            }}
            onChange={(e) => {
              // Update selected users for permissions
              window.selectedUsersGroups = e.selected.map((user) => ({
                id: user.Id,
                type: user.type,
                data: user,
              }));

              // Update add button state
              window
                .$("#addSelectedUsersGroups")
                .prop("disabled", window.selectedUsersGroups.length === 0);
            }}
            remoteSource={async ({ text }) => {
              try {
                const result = await api.sendMessage(
                  "usersGroups/searchReducedUserAndGroups",
                  {
                    user: currentUser(),
                    body: {
                      text: text,
                      searchGroups: true,
                      createNewGuidForLink: true,
                    },
                  }
                );

                return result?.data ?? [];
              } catch (error) {
                console.error("User search error:", error);
                return [];
              }
            }}
          ></Choices>
        }
      </div>
    );
  };

  // Method to open modal for adding users/groups to permissions
  const openAddUserGroupModal = (item) => {
    const addUserGroupModalHtml = `
      <div id="add-user-group-modal" class="modal" tabIndex="-1">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">${t("addUserGroup", {
                ns: "labels",
              })}</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
             <div class='add-users-groups-choices'>
     </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                ${t("close", { ns: "labels" })}
              </button>
              <button type="button" class="btn btn-primary" id="addSelectedUsersGroups" disabled>
                ${t("addSelected", { ns: "labels" })}
              </button>
            </div>
          </div>
        </div>
      </div>
    `;

    // Remove existing modal and add new one
    window.$("#add-user-group-modal").remove();
    window.$("body").append(addUserGroupModalHtml);

    const addModal = window.$("#add-user-group-modal");
    addModal.modal("show");

    // Popola il modal body con il componente Choices
    const modalBodyContainer = window.$(".add-users-groups-choices");
    const choicesComponent = createUserGroupsFinderForPermission();

    // Render the JSX component using ReactDOM
    const root = ReactDOM.createRoot(modalBodyContainer[0]);
    root.render(choicesComponent);

    // Initialize selected users groups
    window.selectedUsersGroups = [];

    // Handle add selected button
    window
      .$("#addSelectedUsersGroups")
      .off("click")
      .on("click", function () {
        if (
          window.selectedUsersGroups &&
          window.selectedUsersGroups.length > 0
        ) {
          // Wait for modal to close completely before reopening permission modal
          addModal.one("hidden.bs.modal", function () {
            addUsersGroupsToPermissions(window.selectedUsersGroups, item);
          });
          addModal.modal("hide");
        }
      });

    // Add selected users/groups to permissions table
    function addUsersGroupsToPermissions(selected, item) {
      // Update permissionsToUse state with new users/groups
      setPermissionToUse((prevPermissions) => {
        const newPermissions = utils.clone(prevPermissions);

        selected.forEach((entity) => {
          if (entity.type === "user") {
            if (!newPermissions.users) newPermissions.users = [];

            var userToUse = {
              Name: entity.data.Name,
              LastName: entity.data.LastName,
              Id: entity.data.Id,
              EMail: entity.data.EMail,
            };

            const newUserPermission = {
              Id: entity.data.NewIdLink, // Use user new Link ID as permission ID for new permissions
              Can_Read: false,
              Can_Write: false,
              Can_List: false,
              Can_Delete: false,
              Can_Execute: false,
              User: userToUse,
              BackEnd_User_Id: entity.data.Id,
            };

            // Add File_Id or Folder_Id based on item type
            if (item.type === "file") {
              newUserPermission.File_Id = item.item.Id;
            } else {
              newUserPermission.Folder_Id = item.item.Id;
            }

            newPermissions.users.push(newUserPermission);
          } else {
            if (!newPermissions.groups) newPermissions.groups = [];

            const newGroupPermission = {
              Id: entity.data.NewIdLink, // Usenew link  group ID as permission ID for new permissions
              Can_Read: false,
              Can_Write: false,
              Can_List: false,
              Can_Delete: false,
              Can_Execute: false,
              Group: entity.data,
              BackEnd_Group_Id: entity.data.Id,
            };

            // Add File_Id or Folder_Id based on item type
            if (item.type === "file") {
              newGroupPermission.File_Id = item.item.Id;
            } else {
              newGroupPermission.Folder_Id = item.item.Id;
            }

            newPermissions.groups.push(newGroupPermission);
          }
        });

        return newPermissions;
      });

      // The table will be automatically updated by the useEffect that watches permissionsToUse
    }
  };

  const permissionModal = async (params) => {
    // Store current item globally for useEffect access
    window.currentPermissionItem = params.item;

    var retrivePermissionResult = await api.sendMessage(
      "dms/retrieveItemPerissions",
      {
        user: currentUser(),
        body: {
          itemType: params.item.type,
          itemId: params.item.item.Id,
        },
      }
    );

    if (retrivePermissionResult.success) {
      let _modal =
        window.$(`<div id="permission-modal" class="modal" tabIndex="-1">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">${t("itemPermission", {
              ns: "labels",
            })}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            </div>
        </div>
      </div>
    </div>`);

      window.$("#permission-modal").remove();
      window.$("body").append(_modal);

      // Add cleanup when modal is hidden
      _modal.on("hidden.bs.modal", function () {
        if (permissionsDataTableRef.current) {
          permissionsDataTableRef.current.destroy();
          permissionsDataTableRef.current = null;
        }
        // Reset permissions state when modal is closed
        setPermissionToUse(null);
        // Clean up global item reference
        window.currentPermissionItem = null;
        window.$(this).remove();
      });

      _modal.modal("show");
      const modal_body = _modal.find(".modal-body");

      setPermissionToUse(utils.clone(retrivePermissionResult.data));
      // Create permissions table with DataTables.js
      createPermissionsTable(modal_body, params.item);
    } else {
    }
  };

  const moveModal = async (params) => {
    let _modal = window.$(`<div id="move-modal" class="modal" tabIndex="-1">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">${t("moveElement", { ns: "labels" })}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p>Modal body text goes here.</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">${t(
          "close",
          { ns: "labels" }
        )}</button>
        <button type="button" class="btn btn-primary">${t("move", {
          ns: "labels",
        })}</button>
      </div>
    </div>
  </div>
</div>`);

    window.$("#move-modal").remove();
    window.$("body").append(_modal);
    _modal.modal("show");
    const modal_body = _modal.find(".modal-body");
    folder_selector_widget({
      user: currentUser(),
      container: modal_body,
      parentId: null,
      currentFolderId: id,
      item: params.item,
      onClick: async (f, item) => {
        var result = await moveItem(f, item);
        if (result.success) {
          if (
            result.inserted.length > 0 &&
            mainDataTableRef.current?.dataTable
          ) {
            var tableSource = mainDataTableRef.current.dataTable
              .rows()
              .data()
              .toArray();
            var index = 0;
            for (var ts of tableSource) {
              index++;
              const tempDiv = document.createElement("div");
              tempDiv.innerHTML = ts[0];
              const dataIdElement = tempDiv.querySelector("[data-id]");
              var sourceId = dataIdElement?.getAttribute("data-id");

              if (sourceId === item.item.Id) {
                mainDataTableRef.current.dataTable
                  .row(index - 1)
                  .remove()
                  .draw();
                window.$("#move-modal").modal("hide");

                window.$(`div[data-id="${item.item.Id}"]`).remove();
              }
            }
          } else {
          }
        } else {
          if (!result.success) {
            withReactContent(Swal).fire({
              title: t("error", { ns: "labels" }),
              icon: "error",
              text: result.message,
              showConfirmButton: true,
            });
          }
        }
      },
    });
  };

  function handleItemClick({ event, props, triggerEvent, data, id }) {
    let realItem;

    let _items = getItems();

    realItem = _items.find((x) => x.item.Id === itemIdForContextMenu);

    switch (id) {
      case "infoContextMenu":
        modifyItem(realItem);
        // window.document.location.href = `/dms/edit/${realItem.item.Id}`;
        break;
      case "editContextMenu":
        //modifyItem(realItem);
        window.document.location.href = `/dms/edit/${realItem.item.Id}`;
        break;
      case "chatContextMenu":
        if (realItem.type === "file") {
          window.location.href = `/dms/chat/${realItem.item.Id}`;
        } else {
          window.location.href = `/dms/chat/folder/${realItem.item.Id}`;
        }
        break;
      case "downloadContextMenu":
        downloadItem({ item: realItem });
        break;
      case "deleteContextMenu":
        showDeleteItemModal(realItem);
        break;
      case "moveContextMenu":
        moveModal({ item: realItem });
        break;

      default:
    }
  }

  function displayMenu(e) {
    // put whatever custom logic you need
    // you can even decide to not display the Menu

    itemIdForContextMenu = e.currentTarget.getAttribute("data-id");

    const itemType = e.currentTarget.getAttribute("data-type");

    if (itemType === "folder") {
      setShowEdit(false);
    } else {
      setShowEdit(true);
    }

    show({
      event: e,
      props: {
        itemType: itemType,
        itemId: itemIdForContextMenu,
      },
    });
  }

  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      setSelected(utils.clone(getItems()));
    } else {
      setSelected([]);
    }
  };

  if (id && process.env.REACT_APP_PROFILE === "AIPLAN") {
    window.$("#dropdownChat").prop("hidden", null);
  }

  const search = async (text) => {
    if (!text) return;
    var result = await api.sendMessage("dms/search", {
      user: currentUser(),
      body: {
        text,
        semanticSearch: semanticSearch,
      },
    });

    return result;
  };

  const advancedSearch = async (
    status,
    classifications,
    keywords,
    categories,
    organizations
  ) => {
    const hasStatus = status !== undefined && status !== null && status !== "";
    const hasOrganizations =
      organizations !== undefined &&
      organizations !== null &&
      organizations !== "";
    const hasKeywords = Array.isArray(keywords) && keywords.length > 0;
    const hasClassifications =
      Array.isArray(classifications) && classifications.length > 0;
    const hasText =
      typeof searchText === "string" && searchText.trim().length > 0;
    const hasCategories = Array.isArray(categories) && categories.length > 0;

    const hasAnyCriteria =
      hasStatus ||
      hasKeywords ||
      hasClassifications ||
      hasCategories ||
      hasText ||
      hasOrganizations;
    // If no filters nor text are provided, restore original content
    if (!hasAnyCriteria) {
      if (mainDataTableRef.current?.dataTable) {
        mainDataTableRef.current.dataTable.destroy();
        mainDataTableRef.current.dataTable = null;
      }
      setContent(originalContent);
      return;
    }

    const result = await api.sendMessage("dms/search", {
      user: currentUser(),
      body: {
        status: status,
        classifications: Array.isArray(classifications) ? classifications : [],
        text: searchText,
        keywords: keywords,
        categories: categories,
        organization: organizations,
      },
    });

    if (result.success) {
      if (mainDataTableRef.current?.dataTable) {
        mainDataTableRef.current.dataTable.destroy();
        mainDataTableRef.current.dataTable = null;
      }
      setContent(utils.clone(result));
    } else {
      withReactContent(Swal).fire({
        title: t("error", { ns: "labels" }),
        icon: "error",
        text: result?.message || t("searchError", { ns: "labels" }),
        showConfirmButton: true,
      });
    }
  };

  const getFolder = async (parentId) => {
    var result = await api.sendMessage("dms/getFolder", {
      user: currentUser(),
      body: {
        id: parentId,
      },
    });

    result.content.path = [];

    if (result.content) {
      let _path = await api.sendMessage("dms/getFolderPath", {
        user: currentUser(),
        body: {
          id: parentId,
        },
      });

      if (_path?.folders) {
        result.content.path = _path.folders.map((f) => {
          return {
            name: f.Name,
            link: `/dms/${f.Id}`,
          };
        });
      }
    }

    result.content.path = [
      {
        link: "/dms",
        name: "DMS",
      },
    ].concat(result.content.path);

    result.content.path = [
      {
        link: "/",
        name: "Home",
      },
    ].concat(result.content.path);

    return result?.content;
  };

  const upload = async (params) => {
    params.user = currentUser();
    uploadManager.fileUpload(params);
  };

  const onUploadFileAdded = (files) => {
    if (mainDataTableRef.current?.dataTable) {
      mainDataTableRef.current.dataTable.destroy();
      mainDataTableRef.current.dataTable = null;
    }
    setContent((prevContent) => {
      const newContent = utils.clone(prevContent);
      for (const f of files) {
        normItem(f);
        const index = newContent.files.findIndex((x) => x.Id == f.Id);
        const isCorrectParent = id ? f.ParentId == id : true;
        if (isCorrectParent) {
          if (index !== -1) {
            newContent.files.splice(index, 1, f);
          } else {
            newContent.files.push(f);
          }
        }
      }
      return newContent;
    });
    setRefresh(new Date());
  };

  const onUploadFolderAdded = (folders) => {
    if (mainDataTableRef.current?.dataTable) {
      mainDataTableRef.current.dataTable.destroy();
      mainDataTableRef.current.dataTable = null;
    }
    setContent((prevContent) => {
      const newContent = utils.clone(prevContent);
      for (const f of folders) {
        normItem(f);
        const index = newContent.folders.findIndex((x) => x.Id == f.Id);
        const isCorrectParent = id ? f.ParentId == id : true;
        if (isCorrectParent) {
          if (index !== -1) {
            newContent.folders.splice(index, 1, f);
          } else {
            newContent.folders.push(f);
          }
        }
      }
      return newContent;
    });
    setRefresh(new Date());
  };

  const handleUploadFileSelect = (e) => {
    const input = e.target;
    const fileList = input.files;
    if (fileList && fileList.length > 0) {
      const files = Array.from(fileList);
      upload({
        files,
        parentId: id,
        onFileAdded: onUploadFileAdded,
        onFolderAdded: onUploadFolderAdded,
      });
    }
    input.value = "";
  };

  const _resizeTable = () => {
    // const _height = window.$(window).height();
    // const _responsive = window.$(".table-responsive");
    // _responsive.css("height", _height );
  };

  useEffect(() => {
    _resizeTable();
    (async () => {
      await loadVocabularies();
    })();
    window.$(window).off("resize");
    window.$(window).on("resize", (e) => {
      _resizeTable();
    });
    (async () => {
      menu.write({ user: currentUser() });
      let _content = await getFolder(id);
      setContent(_content);
      setOriginalContent(_content);
      breadcrumb.set(_content.path);

      switch (mode) {
        case "ai-package":
          {
            let search_result = await search([
              ".aipackage",
              ".aidata",
              ".aimacro",
              ".aisource",
            ]);

            setContent(search_result);
          }
          return;
      }
    })();
  }, []);

  if (id && content?.path) {
    var name = content.path[content.path.length - 1].name;
    window.$("#cardListName").text(`${name}`);
  }

  useEffect(() => {
    (async () => {
      await populateClassifications();
      await populateValidationFlow();
      await populateCategories();
      await populateFileKeywords();
      await populateOrganizationUnitIds();
    })();
  }, [metaData]);

  const modifyItem = async (item) => {
    window.$("#saveRightEditModal").attr("data-id", item.item.Id);
    setItem(utils.clone(item));
    if (item.type === "file") {
      getMetadata(item.item);
      loadDownloadHistory(item.item.Id);
      loadStatusHistory(item.item.Id);
      loadLinkedFiles(item.item.Id);
    }

    const advancedOptionsDiv = window.$("#advancedOptionsDiv");
    const advancedOptionsLink = window.$("#advancedOptionsLink");

    // Check if item is a file (exists in content.files)
    if (item.type === "file") {
      // Show the div and set the correct URL
      advancedOptionsDiv.prop("hidden", false);
      advancedOptionsLink.attr("href", `/dms/itemEdit/file/${item.item.Id}`);
    } else {
      // Hide the div for folders
      advancedOptionsDiv.prop("hidden", true);
    }
  };

  const generateHtmlList = (data, level = 0) => {
    let html = [];
    html.push(`<li>${data.topic}</li>`);
    if (data.children.length > 0) {
      html.push("<ul>");
      data.children.forEach((child) => {
        html = html.concat(generateHtmlList(child, level + 1));
      });
      html.push("</ul>");
    }
    return html.join("");
  };

  const convertTopicJsonToHtml = (topics) => {
    let jsonTopics = JSON.parse(topics);

    return generateHtmlList(jsonTopics[0]);
  };

  const showDeleteItemModal = (item) => {
    withReactContent(Swal)
      .fire({
        title: labels.getText()["CONFIRM_DELETE_MODAL_TITLE"](),
        icon: "warning",
        text: labels.getText()["CONFIRM_DELETE_MODAL_BODY"]({ item: item }),
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: labels.getText()["YES"](),
        cancelButtonText: labels.getText()["NO"](),
        confirmButtonColor: "#DD6B55",
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          deleteItem(item);
          withReactContent(Swal).close();
        }
      });
  };

  const resyncTableSource = () => {
    if (!mainDataTableRef.current?.dataTable) return;

    //table rows
    var tableRows = mainDataTableRef.current.querySelectorAll(`tr[data-id]`);

    //table data source
    var tableSource = mainDataTableRef.current.dataTable
      .rows()
      .data()
      .toArray();

    //sync table versus data
    for (var tr of tableRows) {
      //id of the file or folder to sync
      var idToFind = tr.getAttribute("data-id");

      //datas source item
      var dataSourceItem = tableSource.find((x) => {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = x[0];
        const dataIdElement = tempDiv.querySelector("[data-id]");
        return dataIdElement?.getAttribute("data-id") === idToFind;
      });

      //table item (as array of inner html of cells)
      var itemToAdd = Array.from(tr.querySelectorAll("td")).map(
        (x) => x.innerHTML
      );

      //is it a new element?
      if (!dataSourceItem) {
        mainDataTableRef.current.dataTable.row.add(itemToAdd);
      } else {
        //todo: must execute a resync
      }
    }
  };

  useEffect(() => {}, [selected]);

  useEffect(() => {
    createContextMenu();
  }, [showEdit]);

  // useEffect to redraw permissions table when permissionsToUse changes
  useEffect(() => {
    // Only redraw if the permission modal is open and permissionsToUse is not null
    if (permissionsToUse && window.$("#permission-modal").length > 0) {
      const modal_body = window.$("#permission-modal .modal-body");

      // Destroy existing DataTable if it exists
      if (permissionsDataTableRef.current) {
        permissionsDataTableRef.current.destroy();
        permissionsDataTableRef.current = null;
      }

      // Get the current item from the modal (we need to store it somewhere accessible)
      const currentItem = window.currentPermissionItem;
      if (currentItem) {
        createPermissionsTable(modal_body, currentItem);
      }
    }
  }, [permissionsToUse]);

  const _selectedToolBar = () => {
    if (selected && selected.length > 0) {
      return (
        <div
          style={{
            position: "fixed",
            right: 20,
            bottom: 20,
            width: 30,
            height: 25,
            //border: "1px black solid",
            textAlign: "center",
            opacity: 0.75,
          }}
        >
          <a
            href="#"
            className="btn btn-primary"
            onClick={(e) => {
              showDeleteItemModal(selected);
            }}
          >
            <i class="fa fa-trash fa-1x"></i>
          </a>
        </div>
      );
    }
    return null;
  };

  useLayoutEffect(() => {
    if (!content || !mainDataTableRef.current) return;

    const tableEl = mainDataTableRef.current;

    // Destroy existing DataTable before creating a new one to avoid DOM conflicts
    if (tableEl.dataTable) {
      try {
        tableEl.dataTable.destroy();
        tableEl.dataTable = null;
      } catch (error) {
        // Ignore errors if DataTable was already destroyed
        console.debug("DataTable destroy error (ignored):", error);
      }
    }

    // Initialize or reinitialize DataTable after React has updated the DOM
    // Use setTimeout to ensure React has finished rendering
    setTimeout(() => {
      if (tableEl && !tableEl.dataTable) {
        tableEl.dataTable = new DataTable(tableEl, {
          searching: false,
          pageLength: 50,
          pagingType: "simple_numbers",
          scrollY: 500,
          scrollCollapse: true,
          select: false,
          lengthChange: false,
          ordering: true, // Explicitly enable sorting
          info: true, // Show table info
          autoWidth: false,
          language: {
            paginate: {
              previous: "<",
              next: ">",
            },
          },
          columnDefs: [
            { targets: [0], orderable: false },
            {
              targets: [2, 3],
              render: function (data, type) {
                const tempDiv = document.createElement("div");
                tempDiv.innerHTML = data;
                const dataValueElement = tempDiv.querySelector("[data-value]");
                const _value = dataValueElement
                  ? String(
                      Number(dataValueElement.getAttribute("data-value"))
                    ).padStart(12, "0")
                  : data;
                return type === "sort" ? _value : data;
              },
            },
            { targets: [5], orderable: false },
          ],
        });
        // Add padding to DataTables info area (supports DT v1 and v2 DOM)
        try {
          const wrapper =
            (tableEl.closest && tableEl.closest(".dt-container")) ||
            (tableEl.closest && tableEl.closest(".dataTables_wrapper")) ||
            null;
          if (wrapper) {
            // DataTables 2 selector
            const dtInfo = wrapper.querySelector(".dt-info");
            if (dtInfo) {
              dtInfo.classList.add("px-2", "py-1");
              const infoRow = dtInfo.closest(".dt-layout-row");
              if (infoRow) {
                infoRow.classList.add("px-2", "py-1");
              }
            } else {
              // DataTables 1 selector
              const legacyInfo = wrapper.querySelector(".dataTables_info");
              if (legacyInfo) {
                legacyInfo.classList.add("px-2", "py-1");
              } else {
                // Fallback: pad the last layout row if present
                const layoutRows = wrapper.querySelectorAll(".dt-layout-row");
                const targetRow = layoutRows[layoutRows.length - 1];
                if (targetRow) {
                  targetRow.classList.add("px-2", "py-1");
                }
              }
            }
          }
        } catch (e) {
          // no-op: padding enhancement is best-effort
        }
      }
    }, 0);
   
  }, [content, refresh]);

  // Cleanup DataTable on component unmount
  useEffect(() => {
    return () => {
      if (mainDataTableRef.current?.dataTable) {
        mainDataTableRef.current.dataTable.destroy();
        mainDataTableRef.current.dataTable = null;
      }
    };
  }, []);

  const goToFolder = (id) => {
    window.document.location.href = `/dms/${id}`;
  };

  const getItemSize = (item) => {
    if (item.type === "folder") {
    } else {
      if (item.item.FileSize < 1024) {
        return `${item.item.FileSize} bytes`;
      } else if (item.item.FileSize >= 1024 && item.item.FileSize < 1048576) {
        const kbValue = item.item.FileSize / 1024;
        return `${Math.round(kbValue.toFixed(2).toLocaleString())} KB`;
      } else if (
        item.item.FileSize >= 1048576 &&
        item.item.FileSize < 1073741824
      ) {
        const mbValue = item.item.FileSize / 1024 / 1024;
        return `${Math.round(mbValue.toFixed(2)).toLocaleString()} MB`;
      } else {
        const gbValue = item.item.FileSize / 1024 / 1024 / 1024;
        return `${Math.round(gbValue.toFixed(2)).toLocaleString()} GB`;
      }
    }
  };

  const getName = (item) => {
    const getPath = () => {
      if (item.item?.Path?.Path) {
        if (item.item?.Path?.Path.length > 0) {
          return (
            <>
              <small>in </small>
              <a
                href={`/dms/${
                  item.item.Path.Path[item.item.Path.Path.length - 1].Id
                }`}
              >
                {item.item.Path.Path.map((x) => {
                  if (item.item.Path.Path.findIndex((y) => y == x) == 0) {
                    return <small key={x.Id}>{x.Name}</small>;
                  } else {
                    return (
                      <React.Fragment key={x.Id}>
                        <small> / </small>
                        <small>{x.Name}</small>
                      </React.Fragment>
                    );
                  }
                })}
              </a>
            </>
          );
        }
      }
    };

    if (item.type === "folder") {
      return (
        <h6
          style={{
            opacity: item.item.System_Item ? 0.5 : 1,
          }}
        >
          <img width="28" height="28" src={IconFolder} alt="folder" />
          {item.item.Name}
        </h6>
      );
    } else {
      return (
        <>
          <h6>
            <IconSelector icon={item.item.MimeType} />
            {item.item.Name}
          </h6>
          {getPath()}
        </>
      );
    }
  };

  const normItem = (item) => {
    if (item.ItemLastUpdated)
      item.ItemLastUpdated = new Date(item.ItemLastUpdated);
    if (item.ItemCreated) item.ItemCreated = new Date(item.ItemCreated);
    if (item.ItemDeleted) item.ItemDeleted = new Date(item.ItemDeleted);
    if (item.ExpirationDate)
      item.ExpirationDate = new Date(item.ExpirationDate);
    // Ensure StatusName is populated also for search results that only include a status code
    if (!item.StatusName) {
      const statusCode =
        item.Status ?? item.FileStatus ?? item.StatusCode ?? null;
      if (statusCode !== null && Array.isArray(dmsValidationFlowVoc)) {
        const match = dmsValidationFlowVoc.find(
          (v) => String(v.Code) === String(statusCode)
        );
        if (match && match.Name) {
          item.StatusName = match.Name;
        }
      }
    }
  };

  const openItem = async (item) => {
    switch (item.item.MimeType) {
      case "editorjs/json":
        {
          window.location.href = `/ai-editor?id=${item.item.Id}`;
        }
        break;

      default: {
        if (process.env.REACT_APP_PROFILE === "DARM") {
          if (item.type === "folder") {
            goToFolder(item.item.Id);
          } else {
            await downloadItem({ item });
          }
        } else {
          if (item.type === "folder") {
            goToFolder(item.item.Id);
          } else {
            window.location.href = `/dms/chat/${item.item.Id}`;
          }
        }
      }
    }
  };

  const getTableRow = (item) => {
    return (
      <tr
        key={`file_item.${item.item.Id}`}
        data-id={item.item.Id}
        // style={{ ...dms_style.table_row }}
        className={`${
          highlightedRowId === item.item.Id ? "table-primary" : ""
        }`}
        style={{
          cursor: "pointer",
        }}
      >
        <td>
          <div data-id={item.item.Id} class="form-check custom-checkbox">
            <input
              type="checkbox"
              className="form-check-input"
              onClick={(e) => {
                const _checked = window.$(e.target).is(":checked");
                if (!_checked) {
                  selected.splice(
                    selected.findIndex((x) => x.item.Id == item.item.Id),
                    1
                  );
                } else {
                  selected.push(item);
                }

                setSelected(utils.clone(selected));
              }}
              checked={
                selected.find((x) => x.item.Id == item.item.Id) ? true : false
              }
            />
            <label class="form-check-label"></label>
          </div>
        </td>
        <td
          onClick={(e) => {
            setHighlightedRowId(item.item.Id);
          }}
          onDoubleClick={(e) => {
            return openItem(item);
          }}
        >
          <div class="file-name">
            <div>{getName(item)}</div>
          </div>
        </td>
        <td>
          <span data-value={item.item.FileSize}> {getItemSize(item)}</span>
        </td>
        <td>
          <span
            data-value={
              item.item.ItemLastUpdated
                ? item.item.ItemLastUpdated.getTime()
                : 0
            }
          >
            {item.item.ItemLastUpdated
              ? `${item.item.ItemLastUpdated.toLocaleDateString()} ${item.item.ItemLastUpdated.toLocaleTimeString()}`
              : "-"}
          </span>
        </td>
        <td>{item.item.StatusName}</td>
        <td>
          <div style={{ textAlign: "center" }}>
          <div className="dropdown ms-auto text-end c-pointer threedot">
              <div
                className="btn-link threedotDiv d-flex align-items-center justify-content-center dropdown-header"
                style={{ height: "100%" }}
                data-bs-toggle="dropdown"
                data-bs-boundary="clippingParents"
                data-bs-popper-config='{"strategy":"fixed"}'
                aria-expanded="false"
              >
                <i className="fas fa-ellipsis-v"></i>
              </div>
              <div className="dropdown-menu dropdown-menu-end">
                <a
                  onClick={() => {
                    modifyItem(item);
                  }}
                  className="dropdown-item "
                  data-bs-toggle="offcanvas"
                  href="#editPanel"
                  role="button"
                  aria-controls="editPanel"
                >
                  <i className="fas fa-circle-info me-2"></i>{" "}
                  {t("info", { ns: "labels" })}
                </a>
                {/* edit menu */}

                {item.type === "file" ? (
                  <button
                    onClick={() => {
                      window.location.href = `/dms/edit/${item.item.Id}`;
                    }}
                    className="dropdown-item"
                  >
                    <i className="fas fa-pencil-alt me-2"></i>{" "}
                    {t("edit", { ns: "labels" })}
                  </button>
                ) : null}

                {/* delete */}
                <button
                  onClick={() => {
                    showDeleteItemModal(item);
                  }}
                  className="dropdown-item"
                >
                  <i className="fa fa-trash me-2"></i>
                  {t("delete", { ns: "labels" })}{" "}
                </button>
                {process.env.REACT_APP_PROFILE === "AIPLAN" ? (
                  <button
                    className="dropdown-item"
                    onClick={() => {
                      if (item.type === "file") {
                        window.location.href = `/dms/chat/${item.item.Id}`;
                      } else {
                        window.location.href = `/dms/chat/folder/${item.item.Id}`;
                      }
                    }}
                    hidden={item.type !== "file"&& process.env.REACT_APP_PROFILE === "AIPLAN"}
                  >
                    <i className="fa fa-comment me-2"></i>
                    {t("chat", { ns: "labels" })}
                  </button>
                ) : null}
                <button
                  className="dropdown-item"
                  onClick={async () => {
                    await downloadItem({ item });
                  }}
                >
                  <i className="fa-solid fa-download me-2"></i>
                  {t("download", { ns: "labels" })}
                </button>

                {item.type !== "file" && (
                  <button
                    className="dropdown-item"
                    onClick={() => {
                      toggleFolderGrounding(
                        item.item.Grounding ? "unmake" : "make",
                        { item }
                      );
                    }}
                  >
                    <i className="fa-solid fa-ear-listen me-2"></i>
                    {item.item.Grounding
                      ? t("unmakeGrounding", { ns: "labels" })
                      : t("makeGrounding", { ns: "labels" })}
                  </button>
                )}

                {item.type === "file" && (
                  <button
                    className="dropdown-item"
                    onClick={() => {
                      window.location.href = `/invoice/analyze/${item.item.Id}`;
                    }}
                    hidden
                  >
                    <i className="fa-solid fa-magnifying-glass me-2"></i>
                    {t("analyzeInvoice", { ns: "labels" })}
                  </button>
                )}

                {item.type === "file" &&
                  process.env.REACT_APP_PROFILE === "AIPLAN" && (
                    <button
                      className="dropdown-item"
                      onClick={() => {
                        window.location.href = `/ai-editor?type=${item.type}&id=${item.item.Id}`;
                      }}
                    >
                      <i className="fa-solid fa-magnifying-glass me-2"></i>
                      {t("aiChatEditor", { ns: "labels" })}
                    </button>
                  )}
                {/* documents rights */}
                <button
                  className="dropdown-item"
                  onClick={() => {
                    permissionModal({ item });
                  }}
                >
                  <i className="fa-solid fa-users me-2"></i>
                  {t("itemPermission", { ns: "labels" })}
                </button>

                <hr />
                <button
                  className="dropdown-item"
                  onClick={() => {
                    moveModal({ item });
                  }}
                >
                  <i className="fa fa-folder-tree me-2"></i>
                  {t("move", { ns: "labels" })}
                </button>
              </div>
            </div>
          </div>
        </td>
      </tr>
    );
  };

  const toggleFolderGrounding = async (action, { item }) => {
    const isMakeAction = action === "make";
    const endpoint = isMakeAction
      ? "dms/makeFolderGrounding"
      : "dms/unmakeFolderGrounding";
    const successMessage = isMakeAction
      ? "Folder has been set as grounding successfully"
      : "Folder has been unset as grounding successfully";
    const errorMessage = isMakeAction
      ? "Failed to set folder as grounding"
      : "Failed to unset folder as grounding";

    try {
      const result = await api.sendMessage(endpoint, {
        user: currentUser(),
        body: {
          id: item.item.Id,
        },
      });

      if (result.success) {
        const updatedFolder = result.data.inserted[0];
        const folderIndex = content.folders.findIndex(
          (f) => f.Id === updatedFolder.Id
        );
        if (folderIndex !== -1) {
          content.folders[folderIndex] = updatedFolder;
          setContent(utils.clone(content));
          setRefresh(new Date());
        }

        withReactContent(Swal).fire({
          title: "Success",
          icon: "success",
          text: successMessage,
          showConfirmButton: true,
          confirmButtonText: "Close",
        });
      } else {
        throw new Error(result.message || errorMessage);
      }
    } catch (error) {
      console.error("Error toggling folder grounding:", error);

      withReactContent(Swal).fire({
        title: "Error",
        icon: "error",
        text: `${errorMessage}: ${error.message}`,
        showConfirmButton: true,
        confirmButtonText: "Close",
      });
    }
  };

  const downloadItem = async (item) => {
    const items = Array.isArray(item) ? item : [item];

    for (const i of items) {
      if (i.item.type === "file") {
        // Download file singolo
        // GET request to download file as blob
        const fileBlob = await api.downloadFileGet(
          `dms/wopi/content?id=${i.item.item.Id}`,
          {
            user: currentUser(),
          }
        );

        if (fileBlob && fileBlob.success === undefined) {
          // Create download link and trigger download
          const url = window.URL.createObjectURL(fileBlob);
          const link = document.createElement("a");
          link.href = url;
          link.download = i.item.item.Name || `file_${i.item.item.Id}`;
          document.body.appendChild(link);
          link.click();

          // Cleanup
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        } else {
          withReactContent(Swal).fire({
            title: t("error", { ns: "labels" }),
            icon: "error",
            text: fileBlob.message,
            showConfirmButton: true,
          });
        }
      } else {
        // Download cartella
        const folderBlob = await api.downloadFileGet(
          `dms/downloadFolder/get?id=${i.item.item.Id}`,
          {
            user: currentUser(),
          }
        );

        if (folderBlob && folderBlob.success === undefined) {
          // Create download link and trigger download
          const url = window.URL.createObjectURL(folderBlob);
          const link = document.createElement("a");
          link.href = url;
          link.download = `${
            i.item.item.Name || `folder_${i.item.item.Id}`
          }.zip`;
          document.body.appendChild(link);
          link.click();

          // Cleanup
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        } else {
          withReactContent(Swal).fire({
            title: t("error", { ns: "labels" }),
            icon: "error",
            text: folderBlob.message,
            showConfirmButton: true,
          });
        }
      }
    }
  };

  const moveItem = async (folder, item) => {
    let result;
    if (item.type === "folder") {
      result = await api.sendMessage("dms/moveFolder", {
        user: currentUser(),
        body: {
          folderId: folder.Id,
          itemId: item.item.Id,
        },
      });
    } else {
      result = await api.sendMessage("dms/moveFile", {
        user: currentUser(),
        body: {
          folderId: folder.Id,
          itemId: item.item.Id,
        },
      });
    }
    return result;
  };

  const deleteItem = async (item) => {
    const items = Array.isArray(item) ? item : [item];

    for (const i of items) {
      let deleteResult;
      if (i.type === "folder") {
        deleteResult = await api.sendMessage("dms/deleteFolder", {
          user: currentUser(),
          body: {
            id: i.item.Id,
          },
        });
      } else {
        deleteResult = await api.sendMessage("dms/deleteFile", {
          user: currentUser(),
          body: {
            id: i.item.Id,
          },
        });
      }

      if (deleteResult.success && mainDataTableRef.current?.dataTable) {
        var tableSource = mainDataTableRef.current.dataTable
          .rows()
          .data()
          .toArray();
        var index = 0;
        for (var ts of tableSource) {
          index++;
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = ts[0];
          const dataIdElement = tempDiv.querySelector("[data-id]");
          var sourceId = dataIdElement?.getAttribute("data-id");

          if (sourceId === i.item.Id) {
            mainDataTableRef.current.dataTable
              .row(index - 1)
              .remove()
              .draw();
          }
        }

        window.$(`div[data-id="${i.item.Id}"]`).remove();
        // var tableRows = window.$(".table").find(`tr[data-id]`).toArray();

        resyncTableSource();
      } else {
        withReactContent(Swal).fire({
          title: t("error", { ns: "labels" }),
          icon: "error",
          text: deleteResult.message,
          showConfirmButton: true,
        });
      }
    }
  };

  const getItems = () => {
    if (!content) {
      return [];
    }
    let _folders = content.folders.map((i) => {
      normItem(i);

      return {
        type: "folder",
        item: i,
      };
    });

    let _files = content.files.map((i) => {
      normItem(i);

      return {
        type: "file",
        item: i,
      };
    });

    let _output = [];

    for (var i of _folders) {
      _output.push(i);
    }

    for (var i of _files) {
      _output.push(i);
    }

    return _output;
  };

  const getIcon = (item) => {
    if (item.type === "folder") {
      return <img width="28" height="28" src={IconFolder} alt="folder" />;
    }
    return <IconSelector icon={item.item.MimeType} />;
  };

  const getSmallInfo = (item) => {
    const getPath = () => {
      if (item.item?.Path?.Path) {
        if (item.item?.Path?.Path.length > 0) {
          return (
            <>
              <small>in </small>
              <a
                href={`/dms/${
                  item.item.Path.Path[item.item.Path.Path.length - 1].Id
                }`}
              >
                {item.item.Path.Path.map((x) => {
                  if (item.item.Path.Path.findIndex((y) => y == x) == 0) {
                    return <small key={x.Id}>{x.Name}</small>;
                  } else {
                    return (
                      <React.Fragment key={x.Id}>
                        <small> / </small>
                        <small>{x.Name}</small>
                      </React.Fragment>
                    );
                  }
                })}
              </a>
            </>
          );
        }
      }
    };

    if (item.type === "folder") {
      return <span class="fs-14"></span>;
    }
    return (
      <>
        <span class="fs-14">{getItemSize(item)}</span>
        <br></br>
        <span class="fs-14"> {getPath()}</span>
      </>
    );
  };

  const getEmptyTableRow = (index) => {
    return (
      <tr
        key={`empty.${index}`}
        className="table-empty-row"
        style={{
          cursor: "default",
          pointerEvents: "none",
        }}
      >
        <td>
          <div class="form-check custom-checkbox">
            <input type="checkbox" class="form-check-input" disabled />
            <label class="form-check-label"></label>
          </div>
        </td>
        <td>
          <div class="file-name">
            <div>
              <h6>&nbsp;</h6>
            </div>
          </div>
        </td>
        <td>
          <span>&nbsp;</span>
        </td>
        <td>
          <span>&nbsp;</span>
        </td>
        <td>&nbsp;</td>
        <td>&nbsp;</td>
      </tr>
    );
  };

  const getGridElement = (i) => {
    return (
      <div
        key={`${i.type}.${i.item.Id}`}
        data-id={i.item.Id}
        data-type={i.type}
        class="col-xl-2 col-lg-4 col-sm-6 no-select"
        style={{ cursor: "pointer" }}
        onContextMenu={displayMenu}
        onDoubleClick={(e) => {
          return openItem(i);
        }}
      >
        <div class="card">
          <div class="card-body text-center p-4 d-flex flex-column justify-content-between">
            <div class="m-auto pb-3">{getIcon(i)}</div>
            <div class="clearfix ">
              <h5 class="mb-0">{i.item.Name}</h5>
              {getSmallInfo(i)}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const getGrid = () => {
    let _items = getItems();
    return _items.map((i) => {
      return getGridElement(i);
    });
  };

  const getTable = () => {
    const getTableRows = () => {
      const minRows = 10;
      const items = getItems();
      const rows = items.map((i) => getTableRow(i));
      if (rows.length < minRows) {
        for (let i = rows.length; i < minRows; i++) {
          rows.push(getEmptyTableRow(i));
        }
      }
      return rows;
    };

    if (!content) {
      return (
        <div class="text-center">
          <img src={waiting} />
        </div>
      );
    }

    return (
      <div className="tab-content">
        <div
          className="tab-pane fade active show"
          id="document-list-panel"
          role="tabpanel"
          aria-labelledby="document-list-tab"
          tabIndex="0"
        >
          <table className="table" ref={mainDataTableRef}>
            <thead>
              <tr>
                <th className="col-1">
                  <div class="form-check custom-checkbox">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      id="checkAll"
                      onChange={handleSelectAll}
                      checked={
                        content &&
                        getItems().length > 0 &&
                        selected.length === getItems().length
                      }
                    />
                    <label class="form-check-label" htmlFor="checkAll"></label>
                  </div>
                </th>
                <th className="col-4">{t("name", { ns: "labels" })}</th>
                <th className="col-2">{t("size", { ns: "labels" })}</th>
                <th className="col-1">{t("lastUpdate", { ns: "labels" })}</th>
                <th className="col-1">{t("Status", { ns: "labels" })}</th>
                <th className="text-end col-auto">
                  {t("commands", { ns: "labels" })}
                </th>
              </tr>
            </thead>
            <tbody>
              {content ? (
                getTableRows()
              ) : (
                <div class="text-center">
                  <img src={waiting} />
                </div>
              )}
            </tbody>
          </table>
        </div>
        <div
          class="tab-pane fade"
          id="document-grid-panel"
          role="tabpanel"
          aria-labelledby="document-grid-tab"
          tabIndex="0"
        >
          <div class="row mx-2">{content ? getGrid() : null}</div>
        </div>
      </div>
    );
  };

  const openFolderModal = () => {
    window.$("#createFolderModal").modal("show");
    window.$("#saveFolder").prop("disabled", true);
    window.$("#folderNameInput").val("");
  };

  const createFolderModal = () => {
    return (
      <>
        <div
          class="modal fade"
          id="createFolderModal"
          tabIndex="-1"
          aria-labelledby="createFolderModal"
          aria-hidden="true"
        >
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="createFolderModalHeader">
                  {t("createFolder", { ns: "labels" })}
                </h5>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body">
                <form>
                  <div>
                    <label id="folderNameLabel" class="form-label">
                      {t("folderName", { ns: "labels" })}
                      <span class="text-danger">*</span>
                    </label>
                    <input
                      id="folderNameInput"
                      type="text"
                      class="form-control"
                      onChange={() => {
                        if (window.$("#folderNameInput").val() !== "") {
                          window.$("#saveFolder").prop("disabled", null);
                        } else {
                          window.$("#saveFolder").prop("disabled", true);
                        }
                      }}
                      placeholder={t("insertFolderName", { ns: "labels" })}
                    />
                  </div>
                </form>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  {t("close", { ns: "labels" })}
                </button>
                <button
                  id="saveFolder"
                  type="button"
                  onClick={(e) => {
                    if (window.$("#folderNameInput").val() !== "") {
                      createFolder(window.$("#folderNameInput").val());
                    }
                  }}
                  class="btn btn-primary"
                >
                  {t("save", { ns: "labels" })}
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  const createFolder = async (folderName) => {
    var addFolder = await api.sendMessage("dms/createFolder", {
      user: currentUser(),
      body: {
        parentId: id,
        name: folderName,
      },
    });

    if (addFolder.success) {
      window.$("#folderNameInput").val("");
      normItem(addFolder.folder);

      // Destroy DataTable before updating content to ensure proper reinitialization
      if (mainDataTableRef.current?.dataTable) {
        mainDataTableRef.current.dataTable.destroy();
        mainDataTableRef.current.dataTable = null;
      }

      const newContent = utils.clone(content);
      newContent.folders.push(addFolder.folder);

      // ✅ CORRECTED: Create a clone, modify it, and then set the state
      setContent(newContent);
      setRefresh(new Date());

      window.$("#createFolderModal").modal("hide");
    } else {
      withReactContent(Swal).fire({
        title: t("error", { ns: "labels" }),
        icon: "error",
        text: addFolder.message,
        showConfirmButton: true,
      });
    }
  };

  const _searchChange = async (e) => {
    let _text = e.target.value;
    setSearchText(_text);

    if (!_text) {
      // Destroy DataTable before updating content to avoid DOM conflicts
      if (mainDataTableRef.current?.dataTable) {
        mainDataTableRef.current.dataTable.destroy();
        mainDataTableRef.current.dataTable = null;
      }
      if (searchChangeTimerRef.current) {
        clearTimeout(searchChangeTimerRef.current);
        searchChangeTimerRef.current = null;
      }
      setContent(originalContent);
      return;
    }

    if (searchChangeTimerRef.current) {
      clearTimeout(searchChangeTimerRef.current);
    }

    searchChangeTimerRef.current = setTimeout(async () => {
      if (_text) {
        // Destroy DataTable before updating content to avoid DOM conflicts
        if (mainDataTableRef.current?.dataTable) {
          mainDataTableRef.current.dataTable.destroy();
          mainDataTableRef.current.dataTable = null;
        }
        let search_result = await search(_text);
        setContent(utils.clone(search_result));
      }
    }, 500);
  };

  const _frDraggingEffect = (e, show) => {
    const _path_parts = window.$(".breadcrumb").find("li").toArray();
    const _path = window.$(_path_parts[_path_parts.length - 1]).text();

    const _panel = window.$(`                 
              <div id="dragging-bubble" class="bg-primary"                 
              style="box-shadow: 2px 2px 2px 1px rgb(0 0 0 / 20%); z-index: 10000; position: fixed; bottom: 20px; transform: translateX(-50%); left: 50%; width: 300px; height: 80px; border-radius: 25px; opacity: .1;">
              <div id="dragging-bubble-icon" style="position: absolute; margin-top: -75px; width: 100%; text-align: center;"><img style="width: 100px" src="${cloud_icon}" /></div>
              <div style="position: relative; left: 0; top: 20px; width: 100%; text-align: center; color: white;">Drop files to upload them to</div>
              <div style="padding: 25px; position: relative; left: 0; top: 10px; width: 100%; text-align: center; color: white; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;"><i class="fa fa-folder-tree me-2"></i> ${_path}</div>
            </div>`);

    let _stopSignal = false;
    if (show) {
      if (window.$("#dragging-bubble").length == 0) {
        window.$("body").append(_panel);
        console.log("fr");
        _panel.fadeTo("slow", 1);

        let _direction = "up";

        const _animate = () => {
          const _icon = window.$("#dragging-bubble-icon");
          if (_direction == "up") {
            _icon.animate({ top: "-=25px" }, "slow", () => {
              _direction = "down";
              if (!_stopSignal) _animate();
            });
          } else {
            _icon.animate({ top: "+=25px" }, "slow", () => {
              _direction = "up";
              if (!_stopSignal) _animate();
            });
          }
        };

        _animate();
      }
    } else {
      _stopSignal = true;

      const _icon = window.$("#dragging-bubble-icon");
      _icon.animate({ top: "-=1125px" }, "medium", () => {
        window.$("#dragging-bubble").remove();
      });
    }
  };

  const createContextMenu = () => {
    return (
      <div>
        {/* just display the menu on right click */}
        <Menu id="contextMenu">
          <Item
            id="infoContextMenu"
            class="dropdown-item"
            data-bs-toggle="offcanvas"
            href="#editPanel"
            role="button"
            aria-controls="editPanel"
            onClick={handleItemClick}
          >
            <i class="fas fa-circle-info me-2"></i>
            {t("info", { ns: "labels" })}
          </Item>
          {showEdit ? (
            <Item
              id="editContextMenu"
              class="dropdown-item"
              data-bs-toggle="offcanvas"
              href="#editPanel"
              role="button"
              aria-controls="editPanel"
              onClick={handleItemClick}
            >
              <i class="fas fa-pencil-alt me-2"></i>
              {t("edit", { ns: "labels" })}
            </Item>
          ) : null}
          <Item id="deleteContextMenu" onClick={handleItemClick}>
            <i class="fa fa-trash me-2"></i>
            {t("delete", { ns: "labels" })}
          </Item>
          <Item 
            id="chatContextMenu" 
            onClick={handleItemClick}
            hidden={({ props }) => props?.itemType !== "file" && appProfile === "AIPLAN"}
          >
            <i class="fa fa-comment me-2"></i>
            {t("chat", { ns: "labels" })}
          </Item>
          <Item 
            id="downloadContextMenu" 
            onClick={handleItemClick}
            hidden={({ props }) => props?.itemType === "folder" }
          >
            <i class="fa-solid fa-download me-2"></i>
            {t("download", { ns: "labels" })}
          </Item>
          <Separator />
          {/* <button class="dropdown-item"
                                    onClick={() => {
                                        );
                                    }}><i class="fa fa-folder-tree me-2"></i>Move</button> */}
          <Item id="moveContextMenu" onClick={handleItemClick}>
            <i class="fa fa-folder-tree me-2"></i>
            {t("move", { ns: "labels" })}
          </Item>
        </Menu>
      </div>
    );
  };

  return (
    <>
      <div class="page-titles">
        <ol class="breadcrumb"></ol>
      </div>
      <div
        class="container-fluid vh-100 overflow-y-auto "
        onMouseOver={(e) => {
          window.$("#draggableArea").removeClass("draggableArea");
          _frDraggingEffect();
        }}
        onDragOver={(e) => {
          window.$("#draggableArea").removeClass("draggableArea");
          _frDraggingEffect();
        }}
      >
        <div class="row">
          <div class="col-xl-12">
            <div
              class="card"
              id="draggableArea"
              onDragOver={(e) => {
                e.preventDefault();
                e.stopPropagation();
                if (
                  e.dataTransfer &&
                  e.dataTransfer.items &&
                  e.dataTransfer.items.length > 0
                ) {
                  for (const f of e.dataTransfer.items) {
                    if (f.kind == "file") {
                      const _icon = icons.iconMapping(f.type);
                    }
                  }
                }
              }}
              onMouseOut={(e) => {
                window.$("#draggableArea").removeClass("draggableArea");
              }}
              onDragEnter={(e) => {
                e.preventDefault();
                e.stopPropagation();
                window.$("#draggableArea").addClass("draggableArea");
                _frDraggingEffect(e, true);
              }}
              onDragEnd={(e) => {
                e.preventDefault();
                e.stopPropagation();
                window.$("#draggableArea").removeClass("draggableArea");
              }}
              onDragLeave={(e) => {
                e.preventDefault();
                e.stopPropagation();
                //  window.$("#draggableArea").removeClass("draggableArea");
              }}
              onDrop={async (e) => {
                window.$("#draggableArea").removeClass("draggableArea");
                e.preventDefault();
                e.stopPropagation();
                const _files = await uploadManager.getAllFileEntries(
                  e.dataTransfer.items
                );

                if (_files.files && _files.files.length) {
                  upload({
                    files: _files.files,
                    parentId: id,
                    // ✅ CORRECTED: onFileAdded callback
                    onFileAdded: (files) => {
                      // Destroy DataTable before updating content to ensure proper reinitialization
                      if (mainDataTableRef.current?.dataTable) {
                        mainDataTableRef.current.dataTable.destroy();
                        mainDataTableRef.current.dataTable = null;
                      }
                      setContent((prevContent) => {
                        const newContent = utils.clone(prevContent);

                        for (const f of files) {
                          normItem(f);
                          const index = newContent.files.findIndex(
                            (x) => x.Id == f.Id
                          );
                          // Check if file belongs to current folder using the captured id from drop event
                          // At root level, id is null/undefined, so we compare with f.ParentId
                          const isCorrectParent = id
                            ? f.ParentId == id
                            : true; // At root, always add (backend already validated parent)

                          if (isCorrectParent) {
                            if (index !== -1) {
                              newContent.files.splice(index, 1, f);
                            } else {
                              newContent.files.push(f);
                            }
                          }
                        }
                        return newContent;
                      });
                      // Trigger refresh to reinitialize DataTable
                      setRefresh(new Date());
                    },
                    // ✅ CORRECTED: onFolderAdded callback
                    onFolderAdded: (folders) => {
                      // Destroy DataTable before updating content to ensure proper reinitialization
                      if (mainDataTableRef.current?.dataTable) {
                        mainDataTableRef.current.dataTable.destroy();
                        mainDataTableRef.current.dataTable = null;
                      }
                      setContent((prevContent) => {
                        const newContent = utils.clone(prevContent);

                        for (const f of folders) {
                          normItem(f);
                          const index = newContent.folders.findIndex(
                            (x) => x.Id == f.Id
                          );
                          // Check if folder belongs to current folder using the captured id from drop event
                          // At root level, id is null/undefined, so we compare with f.ParentId
                          const isCorrectParent = id
                            ? f.ParentId == id
                            : true; // At root, always add (backend already validated parent)

                          if (isCorrectParent) {
                            if (index !== -1) {
                              newContent.folders.splice(index, 1, f);
                            } else {
                              newContent.folders.push(f);
                            }
                          }
                        }
                        return newContent;
                      });
                      // Trigger refresh to reinitialize DataTable
                      setRefresh(new Date());
                    },
                  });
                }
              }}
            >
              <div className="card-body p-0 ">
                <div
                  className="table-responsive active-projects task-table"
                  style={{}}
                >
                  <div className="tbl-caption">
                    <div className="row">
                      <div className="col-3 mb-3 ">
                        <h4
                          id="cardListName"
                          className="heading mb-0 text-start"
                        >
                          {t("filesList", { ns: "labels" })}
                        </h4>
                      </div>
                      <div className="col-6  mb-2 d-flex flex-column align-items-start">
                        <div className="input-group mb-2">
                          <input
                            type="search"
                            className="form-control input-rounded"
                            placeholder={t("search", { ns: "labels" })}
                            onChange={_searchChange}
                          />
                          <button
                            className="btn bg-white border border-start-0 btn-rounded-end-pill"
                            type="button"
                            data-bs-toggle="dropdown"
                            data-bs-auto-close="outside"
                            aria-expanded="false"
                          >
                            <i
                              className="ms-1 me-2 fa fa-chevron-down"
                              aria-hidden="true"
                            ></i>
                          </button>
                          <div
                            className="dropdown-menu dropdown-menu p-3 w-100  rounded-4 border shadow-none "
                            style={{
                              minWidth: 280,
                              height: 280,
                              outlineColor: "initial",
                            }}
                            onClick={(e) => e.stopPropagation()}
                          >
                            <div className="mb-2">
                              <label className="form-label mb-1 ">
                                {t("AdvancedSearch", { ns: "labels" })}
                              </label>
                            </div>
                            <div className="row">
                              <div className="mb-2 col-6">
                                <label className="form-label mb-1">
                                  {t("classification", { ns: "labels" })}
                                </label>
                                <Select
                                  isMulti
                                  placeholder={t("select", { ns: "labels" })}
                                  name="classifications"
                                  options={dmsClassificationVoc.map((item) => ({
                                    value: item.Code,
                                    label: item.Name,
                                  }))}
                                  onChange={(value) => {
                                    setSelectedClassificationForSearch(value);
                                  }}
                                  value={selectedClassificationForSearch}
                                  className="basic-multi-select"
                                  classNamePrefix="select"
                                  menuPlacement="auto"
                                  menuPosition="fixed"
                                  menuPortalTarget={document.body}
                                  styles={{
                                    menuPortal: (base) => ({
                                      ...base,
                                      zIndex: 2000,
                                    }),
                                    menu: (base) => ({
                                      ...base,
                                      zIndex: 2000,
                                      overflowY: "auto",
                                    }),
                                    valueContainer: (base) => ({
                                      ...base,
                                      flexWrap: "nowrap",
                                    }),
                                  }}
                                />
                              </div>
                              <div className="mb-2 col-6">
                                <label className="form-label mb-1">
                                  {t("status", { ns: "labels" })}
                                </label>
                                <Select
                                  onChange={(value) =>
                                    setSelectedStatusForSearch(value)
                                  }
                                  name="Status"
                                  placeholder={t("select", { ns: "labels" })}
                                  options={dmsValidationFlowVoc.map((item) => ({
                                    value: item.Code,
                                    label: item.Name,
                                  }))}
                                  isClearable={true}
                                  className="basic-multi-select"
                                  classNamePrefix="select"
                                  value={selectedStatusForSearch}
                                  menuPlacement="auto"
                                  menuPosition="fixed"
                                  menuPortalTarget={document.body}
                                  styles={{
                                    menuPortal: (base) => ({
                                      ...base,
                                      zIndex: 2000,
                                    }),
                                    menu: (base) => ({
                                      ...base,
                                      zIndex: 2000,
                                      overflowY: "auto",
                                    }),
                                    valueContainer: (base) => ({
                                      ...base,
                                      flexWrap: "nowrap",
                                    }),
                                  }}
                                />
                              </div>
                              <div className="mb-2 col-6">
                                <label className="form-label mb-1">
                                  {t("dmsCategory", { ns: "labels" })}
                                </label>
                                <Select
                                  isMulti
                                  placeholder={t("select", { ns: "labels" })}
                                  name="Categories"
                                  options={dmsCategoriesVoc.map((item) => ({
                                    value: item.Code,
                                    label: item.Name,
                                  }))}
                                  onChange={(value) =>
                                    setSelectedCategoriesForSearch(value)
                                  }
                                  value={selectedCategoriesForSearch}
                                  className="basic-multi-select"
                                  classNamePrefix="select"
                                  menuPlacement="auto"
                                  menuPosition="fixed"
                                  menuPortalTarget={document.body}
                                  styles={{
                                    menuPortal: (base) => ({
                                      ...base,
                                      zIndex: 2000,
                                    }),
                                    menu: (base) => ({
                                      ...base,
                                      zIndex: 2000,
                                      overflowY: "auto",
                                    }),
                                    valueContainer: (base) => ({
                                      ...base,
                                      flexWrap: "nowrap",
                                    }),
                                  }}
                                />
                              </div>
                              <div className="mb-2 col-6">
                                <label className="form-label mb-1">
                                  {t("keywords", { ns: "labels" })}
                                </label>
                                <Select
                                  isMulti
                                  placeholder={t("select", { ns: "labels" })}
                                  name="Keywords"
                                  options={allKeywords.map((item) => ({
                                    value: item.Keyword,
                                    label: item.Keyword,
                                  }))}
                                  onChange={(value) =>
                                    setSelectedKeywordsForSearch(value)
                                  }
                                  value={selectedKeywordsForSearch}
                                  className="basic-multi-select"
                                  classNamePrefix="select"
                                  menuPlacement="auto"
                                  menuPosition="fixed"
                                  menuPortalTarget={document.body}
                                  styles={{
                                    menuPortal: (base) => ({
                                      ...base,
                                      zIndex: 2000,
                                    }),
                                    menu: (base) => ({
                                      ...base,
                                      zIndex: 2000,
                                      overflowY: "auto",
                                    }),
                                    valueContainer: (base) => ({
                                      ...base,
                                      flexWrap: "nowrap",
                                    }),
                                  }}
                                />
                              </div>
                              <div className="mb-2 col-6">
                                <label className="form-label mb-1">
                                  {t("businessUnit", { ns: "labels" })}
                                </label>
                                <AsyncSelect
                                  cacheOptions
                                  loadOptions={searchOrganizationUnits}
                                  className="basic-multi-select w-100"
                                  classNamePrefix="select"
                                  isClearable={true}
                                  menuPlacement="auto"
                                  menuPosition="fixed"
                                  placeholder="Type to search organizations"
                                  onChange={(value) =>
                                    setSelectedOrganizationsForSearch(value)
                                  }
                                  value={selectedOrganizationsForSearch}
                                  menuPortalTarget={document.body}
                                  styles={{
                                    menuPortal: (base) => ({
                                      ...base,
                                      zIndex: 2000,
                                    }),
                                    menu: (base) => ({
                                      ...base,
                                      zIndex: 2000,
                                      overflowY: "auto",
                                    }),
                                    valueContainer: (base) => ({
                                      ...base,
                                      flexWrap: "nowrap",
                                    }),
                                  }}
                                />
                              </div>
                              <div className="mb-2 col-6 d-flex justify-content-end align-items-end">
                                <button
                                  type="button"
                                  className="btn btn-primary d-flex align-items-center"
                                  disabled={isAdvancedSearchLoading}
                                  onClick={async () => {
                                    setIsAdvancedSearchLoading(true);
                                    try {
                                      await advancedSearch(
                                        selectedStatusForSearch?.value,
                                        selectedClassificationForSearch.map(
                                          (o) => o.value
                                        ),
                                        selectedKeywordsForSearch.map(
                                          (o) => o.value
                                        ),
                                        selectedCategoriesForSearch.map(
                                          (o) => o.value
                                        ),
                                        selectedOrganizationsForSearch?.value
                                      );
                                    } finally {
                                      setIsAdvancedSearchLoading(false);
                                    }
                                  }}
                                >
                                  {isAdvancedSearchLoading && (
                                    <span
                                      className="spinner-border spinner-border-sm me-2"
                                      role="status"
                                      aria-hidden="true"
                                    ></span>
                                  )}
                                  {t("search", { ns: "labels" })}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        id=""
                        className=" col-2 mb-3 d-flex align-items-center"
                      >
                        <ul
                          className="nav nav-pills"
                          id="myTabView"
                          role="tablist"
                        >
                          <li className="nav-item ms-1" role="presentation">
                            <button
                              className="nav-link btn btn-light btn-sharp p-0 active"
                              id="document-list-tab"
                              data-bs-toggle="tab"
                              data-bs-target="#document-list-panel"
                              type="button"
                              role="tab"
                              aria-controls="document-list-panel"
                              aria-selected="true"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="feather feather-list"
                              >
                                <line x1="8" y1="6" x2="21" y2="6"></line>
                                <line x1="8" y1="12" x2="21" y2="12"></line>
                                <line x1="8" y1="18" x2="21" y2="18"></line>
                                <line x1="3" y1="6" x2="3.01" y2="6"></line>
                                <line x1="3" y1="12" x2="3.01" y2="12"></line>
                                <line x1="3" y1="18" x2="3.01" y2="18"></line>
                              </svg>
                            </button>
                          </li>
                          <li className="nav-item ms-1" role="presentation">
                            <button
                              className="nav-link btn btn-light btn-sharp p-0"
                              id="document-grid-tab"
                              data-bs-toggle="tab"
                              data-bs-target="#document-grid-panel"
                              type="button"
                              role="tab"
                              aria-controls="document-grid-panel"
                              aria-selected="false"
                              tabIndex="-1"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="feather feather-grid"
                              >
                                <rect x="3" y="3" width="7" height="7"></rect>
                                <rect x="14" y="3" width="7" height="7"></rect>
                                <rect x="14" y="14" width="7" height="7"></rect>
                                <rect x="3" y="14" width="7" height="7"></rect>
                              </svg>
                            </button>
                          </li>
                        </ul>
                      </div>

                      <div className="dropdown text-end threedot d-flex align-items-center justify-content-end col-1 mb-1">
                        <button
                          type="button"
                          className="btn btn-link threedotDiv d-flex align-items-center justify-content-center  p-0"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <i className="fas fa-ellipsis-v"></i>
                        </button>
                        <div className="dropdown-menu dropdown-menu-end">
                          <button
                            onClick={() => {
                              openFolderModal();
                            }}
                            className="dropdown-item"
                          >
                            {" "}
                            <i className="fa-solid fa-folder-plus me-2"></i>
                            {t("createFolder", { ns: "labels" })}
                          </button>
                          <input
                            ref={uploadFileInputRef}
                            type="file"
                            multiple
                            style={{ display: "none" }}
                            onChange={handleUploadFileSelect}
                          />
                          <button
                            type="button"
                            onClick={() => uploadFileInputRef.current?.click()}
                            className="dropdown-item"
                          >
                            <i className="fa-solid fa-upload me-2"></i>
                            {t("uploadDocument", { ns: "labels" })}
                          </button>

                          <button
                            className="dropdown-item"
                            id="dropdownChat"
                            onClick={() => {
                              window.location.href = `/dms/chat/folder/${id}`;
                            }}
                            hidden
                          >
                            <i className="fa fa-comment me-2"></i>
                            {t("chat", { ns: "labels" })}
                          </button>
                        </div>
                      </div>
                    </div>
                    {process.env.REACT_APP_PROFILE === "AIPLAN" ? (
                      <div className="row justify-content-center ">
                        <div className="form-check form-switch d-flex align-items-center justify-content-center">
                          <input
                            className="form-check-input me-2"
                            type="checkbox"
                            role="switch"
                            id="semanticSearchSwitch"
                            checked={semanticSearch}
                            onChange={() => {
                              setSemanticSearch(!semanticSearch);
                            }}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="semanticSearchSwitch"
                          >
                            {t("semanticSearch")}
                          </label>
                        </div>
                      </div>
                    ) : null}
                  </div>

                  {getTable()}
                </div>
              </div>
            </div>
          </div>
        </div>
        <EditPanelProvider
          value={{
            item,
            setItem,
            toSave,
            setToSave,
            isSavingRightEditModal,
            setIsSavingRightEditModal,
            dmsClassificationVoc,
            dmsCategoriesVoc,
            dmsValidationFlowVoc,
            dmsFileKeywords,
            allKeywords,
            selectedClassifications,
            setSelectedClassifications,
            selectedValidation,
            selectedOrganizationUnitIds,
            setSelectedOrganizationUnitIds,
            setSelectedValidation,
            selectedCategories,
            setSelectedCategories,
            selectedFileKeywords,
            setSelectedFileKeywords,
            getItemSize,
            downloadHistory,
            statusHistory,
            userRights,
            linkedFilesManager: {
              linkedFiles,
              setLinkedFiles,
              loadLinkedFiles,
            },
            CanIEditLinkedFile,
          }}
        >
          <EditPanel />
        </EditPanelProvider>
        {createFolderModal()}
        {createContextMenu()}
        {_selectedToolBar()}
      </div>
    </>
  );
}

export { DMS_Screen };
